// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetAsrHotWordsModelsByIdParam,
    BaseResponseAsrHotWordsModelFoundResponse,
    PutAsrHotWordsModelsByIdParam,
    PutAsrHotWordsModelsByIdBody,
    BaseResponseVoid,
    DeleteAsrHotWordsModelsByIdParam,
} from '../../types';

/**
 * findById
 *
 * @export
 * @tags asr-hot-words-model-controller
 * @link [GET] /asrHotWordsModels/{id}
 * @param id
 */
export function getAsrHotWordsModelsById(
    options: ApiOptions<GetAsrHotWordsModelsByIdParam, never> & {
        segments: GetAsrHotWordsModelsByIdParam;
    }
): Promise<BaseResponseAsrHotWordsModelFoundResponse> {
    return request<never, GetAsrHotWordsModelsByIdParam, never>('/asrHotWordsModels/{id}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAsrHotWordsModelsById',
    });
}

/**
 * 修改热词模型
 *
 * @export
 * @tags asr-hot-words-model-controller
 * @link [PUT] /asrHotWordsModels/{id}
 * @param id
 */
export function putAsrHotWordsModelsById(
    data: PutAsrHotWordsModelsByIdBody,
    options: ApiOptions<PutAsrHotWordsModelsByIdParam, never> & {
        segments: PutAsrHotWordsModelsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<PutAsrHotWordsModelsByIdBody, PutAsrHotWordsModelsByIdParam, never>(
        '/asrHotWordsModels/{id}',
        { ...options, data, method: 'put', __$requestCalleeName: 'putAsrHotWordsModelsById' }
    );
}

/**
 * 删除热词模型
 *
 * @export
 * @tags asr-hot-words-model-controller
 * @link [DELETE] /asrHotWordsModels/{id}
 * @param id
 */
export function deleteAsrHotWordsModelsById(
    options: ApiOptions<DeleteAsrHotWordsModelsByIdParam, never> & {
        segments: DeleteAsrHotWordsModelsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteAsrHotWordsModelsByIdParam, never>('/asrHotWordsModels/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteAsrHotWordsModelsById',
    });
}

export const meta = [
    { tags: ['asr-hot-words-model-controller'], path: '/asrHotWordsModels/{id}', method: 'get' },
    { tags: ['asr-hot-words-model-controller'], path: '/asrHotWordsModels/{id}', method: 'put' },
    { tags: ['asr-hot-words-model-controller'], path: '/asrHotWordsModels/{id}', method: 'delete' },
];
